import io from "socket.io-client";

const serverUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:4000';
const wsURL = 'ws' + serverUrl.slice(4) + '/team/';
const socket = io.connect(wsURL);

socket.on("connect", (socket) => {});

export default socket;
